var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Page, TabsWithContent } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { facebookMessengerApi } from 'apis/facebookMessenger';
import { messagingApi } from 'apis/messaging';
import { twitterApi } from 'apis/twitter';
import { Facebook } from './components/facebook/facebook';
import { Instagram } from './components/instagram/instagram';
import { Twitter } from './components/twitter/twitter';
import { Whatsapp } from './components/whatsapp/whatsapp';
import styles from './settingsMessaging.module.scss';
export const SettingsMessagingView = () => {
    const { facebookApps } = facebookMessengerApi.useReadApplicationsQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { facebookApps: (data === null || data === void 0 ? void 0 : data.data.applications) || [] }));
        },
    });
    const { whatsAppNumbers } = messagingApi.useReadAppsQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { whatsAppNumbers: (data === null || data === void 0 ? void 0 : data.data.applications) || [] }));
        },
    });
    const { twitterAccounts } = twitterApi.useReadAccountsQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { twitterAccounts: (data === null || data === void 0 ? void 0 : data.data.accounts) || [] }));
        },
    });
    const { numberOfFacebookPages, numberOfInstagramAccounts } = useMemo(() => {
        const numberOfFacebookPages = facebookApps.reduce((count, current) => count + current.pages.length, 0);
        const numberOfInstagramAccounts = facebookApps.reduce((count, current) => count + current.instagram_accounts.length, 0);
        return { numberOfFacebookPages, numberOfInstagramAccounts };
    }, [facebookApps]);
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Third-party messaging" }), _jsx(Page.Body, { children: _jsx(Page.Section, { children: _jsxs(TabsWithContent, Object.assign({ initiallySelectedTabId: "facebook", tabs: [
                            {
                                id: 'facebook',
                                label: 'Facebook',
                                slotEnd: numberOfFacebookPages ? (_jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: numberOfFacebookPages }))) : null,
                            },
                            {
                                id: 'instagram',
                                label: 'Instagram',
                                slotEnd: numberOfInstagramAccounts ? (_jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: numberOfInstagramAccounts }))) : null,
                            },
                            {
                                id: 'twitter',
                                label: 'Twitter',
                                slotEnd: twitterAccounts.length ? (_jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: twitterAccounts.length }))) : null,
                            },
                            {
                                id: 'whatsapp',
                                label: 'WhatsApp',
                                slotEnd: whatsAppNumbers.length ? (_jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: whatsAppNumbers.length }))) : null,
                            },
                        ], tabsClassName: styles.tabs, childrenWrapperClassName: styles.children, className: styles.content }, { children: [_jsx(Facebook, {}), _jsx(Instagram, {}), _jsx(Twitter, {}), _jsx(Whatsapp, {})] })) }) })] }));
};
